'use client';

import {
  ComponentType,
  createContext,
  Dispatch,
  PropsWithChildren,
  SetStateAction,
  useContext,
  useMemo,
  useState,
} from 'react';
import { ModalWindowComponent } from '../components/common/Modal';
import { initialModalState, ModalState } from '../models/modal';

export const ModalContext = createContext<{
  modalState: ModalState;
  setModalState: Dispatch<SetStateAction<ModalState>>;
  Modal: ComponentType | null;
}>({
  Modal: null,
  modalState: {
    content: null,
    show: false,
  },
  setModalState: () => {},
});

function ModalComponent(
  modalState: ModalState,
  setModalState: Dispatch<SetStateAction<ModalState>>
) {
  return modalState.show ? (
    <ModalWindowComponent
      outsideCloseCallback={modalState.outsideCloseCallback}
      content={modalState.content}
      options={modalState.options}
      setModalState={setModalState}
      enableOutsideClick={modalState.enableOutsideClick}
    />
  ) : null;
}

export function ModalProvider({ children }: PropsWithChildren) {
  const [modalState, setModalState] = useState<ModalState>(initialModalState);
  // eslint-disable-next-line react/no-unstable-nested-components
  const contextValue = useMemo(
    () => ({
      modalState,
      setModalState,
      Modal: () => ModalComponent(modalState, setModalState),
    }),
    [modalState]
  );
  return (
    <ModalContext.Provider value={contextValue}>
      {children}
    </ModalContext.Provider>
  );
}

export function useModal() {
  return useContext(ModalContext);
}
